import { createSelector } from "reselect";
export var reportsCenterStateSelector = function(state) {
    return state.reportsCenter;
};
export var generateReportStateSelector = function(state) {
    return state.generateReport;
};
/**
 * Selects the lps that selected in the dropdown.
 */ export var lpSelectedSelector = createSelector(reportsCenterStateSelector, function(param) {
    var lpSelected = param.lpSelected;
    return lpSelected;
});
export var termReportConfigsSelector = createSelector(reportsCenterStateSelector, function(reportsCenterState) {
    var _reportsCenterState_termReportConfigs;
    return (_reportsCenterState_termReportConfigs = reportsCenterState === null || reportsCenterState === void 0 ? void 0 : reportsCenterState.termReportConfigs) !== null && _reportsCenterState_termReportConfigs !== void 0 ? _reportsCenterState_termReportConfigs : [];
});
export var getTermReportConfigsErrorSelector = createSelector(reportsCenterStateSelector, function(param) {
    var getTermReportConfigsError = param.getTermReportConfigsError;
    return getTermReportConfigsError;
});
export var reportsListSelector = createSelector(reportsCenterStateSelector, function(param) {
    var reportsList = param.reportsList;
    return reportsList;
});
export var reportsListTotalRecordsSelector = createSelector(reportsCenterStateSelector, function(reportsCenterState) {
    var _reportsCenterState_reportsListTotalRecords;
    return (_reportsCenterState_reportsListTotalRecords = reportsCenterState === null || reportsCenterState === void 0 ? void 0 : reportsCenterState.reportsListTotalRecords) !== null && _reportsCenterState_reportsListTotalRecords !== void 0 ? _reportsCenterState_reportsListTotalRecords : [];
});
export var searchReportsPageSizeSelector = createSelector(reportsCenterStateSelector, function(param) {
    var searchReportsPageSize = param.searchReportsPageSize;
    return searchReportsPageSize;
});
export var bulkFilesPartsUploadSelector = createSelector(reportsCenterStateSelector, function(param) {
    var bulkFilesPartsUpload = param.bulkFilesPartsUpload;
    return bulkFilesPartsUpload;
});
export var isTriggerSearchReportSelector = createSelector(reportsCenterStateSelector, function(param) {
    var isTriggerSearchReport = param.isTriggerSearchReport;
    return isTriggerSearchReport;
});
export var currentFolderPathSelector = createSelector(reportsCenterStateSelector, function(param) {
    var currentFolderPath = param.currentFolderPath;
    return currentFolderPath;
});
export var currentPageSelector = createSelector(reportsCenterStateSelector, function(param) {
    var currentPage = param.currentPage;
    return currentPage;
});
export var selectedReportsSelector = createSelector(reportsCenterStateSelector, function(param) {
    var selectedReports = param.selectedReports;
    return selectedReports;
});
export var sortCriteriaSelector = createSelector(reportsCenterStateSelector, function(param) {
    var sortCriteria = param.sortCriteria;
    return sortCriteria;
});
export var getPresignedUrl = createSelector(generateReportStateSelector, function(param) {
    var presignedURL = param.presignedURL;
    return presignedURL;
});
export var selectDDUList = createSelector(generateReportStateSelector, function(param) {
    var dduList = param.dduList;
    return dduList;
});
export var getReportIdGenerated = createSelector(generateReportStateSelector, function(param) {
    var reportValue = param.reportValue;
    return reportValue;
});
export var selectIsGenerateReportTriggered = createSelector(generateReportStateSelector, function(param) {
    var isTriggerGenerateReport = param.isTriggerGenerateReport;
    return isTriggerGenerateReport;
});
export var getPresignedDownloadUrl = createSelector(reportsCenterStateSelector, function(param) {
    var downloadReportPresignedURL = param.downloadReportPresignedURL;
    return downloadReportPresignedURL;
});
export var getCSVData = createSelector(generateReportStateSelector, function(param) {
    var csvData = param.csvData;
    return csvData;
});
export var isTriggerFetchDataFromPresignedURL = createSelector(generateReportStateSelector, function(param) {
    var isTriggerFetchDataFromPresignedURL = param.isTriggerFetchDataFromPresignedURL;
    return isTriggerFetchDataFromPresignedURL;
});
export var reportDetailsSelector = createSelector(reportsCenterStateSelector, function(param) {
    var reportDetails = param.reportDetails;
    return reportDetails;
});
export var filterSheetOpenSelector = createSelector(reportsCenterStateSelector, function(param) {
    var filterSheetOpen = param.filterSheetOpen;
    return filterSheetOpen;
});
export var filtersSelector = createSelector(reportsCenterStateSelector, function(param) {
    var filters = param.filters;
    return filters;
});
export var isGetReportDetailsPollingSelector = createSelector(reportsCenterStateSelector, function(param) {
    var isGetReportDetailsPolling = param.isGetReportDetailsPolling;
    return isGetReportDetailsPolling;
});

//# sourceMappingURL=selectors.js.map